<template>
  <div :class="pointsClasses">
    {{ Math.abs(value) | price }} {{ value | decl('бонус', ['', 'а', 'ов']) }}
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    isAddMode: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    pointsClasses() {
      const base = 'club-points-history-table-row-points';
      const modeClass = this.isAddMode ? '_add' : '_burns';

      return [base, base + modeClass];
    },
  }
}
</script>

<style lang="scss">
  .club-points-history-table-row-points {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    display: flex;

    &::before {
      display: inline;
      margin-right: 4px;
    }

    &_add {
      color: $blue;

      &::before {
        content: '+';
      }
    }

    &_burns {
      color: $purple;

      &::before {
        content: '-';
      }
    }
  }

</style>